import React, { useContext, useState } from "react";
import styled from "styled-components";
import _ from "lodash";
import {
  deletePortalAccount,
  editPortalAccount,
  loadProfile,
  assignTrainer,
  bulkRemoveTrainer,
  assignToGroup,
  bulkRemoveFromGroup,
  batchSetVacationMode,
} from "../../../../../api";
import { withRouter } from "react-router-dom";
import { AuthContext } from "../../../../../auth-context";
import moment from "moment";
import Modal from "../../../../../components/modal";
import EditIcon from "@material-ui/icons/Edit";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import LinkIcon from "@material-ui/icons/Link";
import { TrainerButton } from "./trainer-button";
import { GroupButton } from "./group-button";
import DeleteIcon from "@material-ui/icons/DeleteForever";
import SearchIcon from "@material-ui/icons/Search";
import { DashboardContext } from "../../../dashboard-context";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";
import { ThemeContext } from "styled-components";
import {
  CustomPopover,
  PopoverListItem,
} from "../../../../../components/popover";
import { Row } from "../../../../../components/action-button";
import { DarkTooltip } from "../../../../../components/tooltip";
import { AddCircle, People } from "@material-ui/icons";
import Input from "../../../../../components/input";
import HelpTip from "../../../../../components/help-tip";
import Checkbox from "@material-ui/core/Checkbox";
import { TrainerLinkButton } from "./trainer-link-button";
import { ReactComponent as ArrowUp } from "../../../../../images/arrow-up.svg";
import { ReactComponent as ArrowDown } from "../../../../../images/arrow-down.svg";
import { ErrorMessage } from "../../../../../components/error-message";
import { WarningMessage } from "../../../../../components/warning-message";
import { BulkAssignTrainer } from "./bulk-actions/bulk-assign-trainer";
import { BulkEditGroups } from "./bulk-actions/bulk-edit-groups";
import Papa from "papaparse";

const WhiteCheckbox = withStyles({})((props) => (
  <Checkbox color="default" {...props} />
));

const BiggerFontTooltip = withStyles({
  tooltip: {
    fontSize: "14px",
  },
})(Tooltip);

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`;

const TableTitle = styled.h2`
  display: flex;
  align-items: flex-start;
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`;

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`;

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;
`;

const TableHead = styled.thead`
  color: #fff;
`;

const TableBody = styled.tbody``;

const TableHeadRow = styled.tr``;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 0.9rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${(props) => (props.bigWidth ? "160px" : "100px")};
  padding: 8px;
  position: sticky;
  text-align: left;
  top: 0;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  font-size: 0.9rem;
  padding: 4px 8px;
  text-align: left;
`;

const ButtonCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-size: 0.9rem;
  padding: 4px 8px;
`;

const RemoveText = styled.h4`
  color: #555;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
`;

const LinkContainer = styled.div`
  font-weight: 400;
  padding: 0px 12px
  margin: 16px 0;

  >div {
    display: flex;
    align-items: center;

    p {
      margin-bottom: 0px;
      padding-left: 2px;
      padding-right: 4px;
    }
  }
`;

const ArrowsGroup = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const EmailText = styled.p`
  display: flex;
  font-size: 0.8rem !important;
  svg {
    margin-right: 8px;
  }
`;

const BulkEdit = styled.button`
  background: ${(props) =>
    props.highlight ? props.theme.color.primary : props.theme.color.dark};
  border: none;
  border-radius: 100px;
  color: #fff;
  cursor: pointer;
  font-size: .8rem;
  padding: 6px 12px;
  margin-left: 8px;
  transition: 0.3s ease all;
`;

const Export = styled(BulkEdit)``;

const BulkAction = styled(BulkEdit)`
  background: ${(props) => props.theme.color.dark};
`;

const AccountsTable = (props) => {
  const { clientSearch, openSnackbar } = useContext(DashboardContext);
  const { user, updateUser } = useContext(AuthContext);
  const theme = useContext(ThemeContext);
  const [name, updateName] = useState("");
  const [email, updateEmail] = useState("");
  const [showModal, updateShowModal] = useState(false);
  const [deletionID, updatedeletionID] = useState("");
  const [deletionEmail, updatedeletionEmail] = useState("");
  const [loading, updateLoading] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [error, updateError] = useState("");
  const [checked, setChecked] = useState(false);
  const [linkData, setLinkData] = useState("");
  const [prevAccountData, setPrevAccountData] = useState("");
  const [sortType, setSortType] = useState({ type: "name", reverse: false });
  const [showSelect, setShowSelect] = useState(null);
  const [showAssignModal, setShowAssignModal] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [assignType, setAssignType] = useState("");
  const [bulkLoading, setBulkLoading] = useState(false);
  const [groupEditType, setGroupEditType] = useState("");
  const [showGroupModal, setShowGroupModal] = useState(false);

  const handleDelete = (accountID) => {
    updateLoading(true);

    deletePortalAccount(user.id, accountID)
      .then((res) => {
        let newUser = Object.assign({}, user);
        _.remove(newUser.accounts, (account) => {
          return account.id === accountID;
        });

        setTimeout(() => {
          updateLoading(false);
          updateShowModal(false);
          updateUser(newUser);
          openSnackbar("Account successfully removed", false);
        }, 700);
      })
      .catch((err) => {
        updateLoading(false);
        openSnackbar("Error deleting account", true);
      });
  };

  const emailIsValid = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const openEditModal = (entry) => {
    setShowEditModal(true);
    updateEmail(entry.email_address);
    updateName(entry.name);
    setPrevAccountData({
      id: entry.id,
      email_address: entry.email_address,
      name: entry.name,
      link_data: {
        trainer_id: entry.linked_portal_id,
      },
    });
    if (entry.linked_portal_id) {
      setChecked(true);
      setLinkData({
        id: entry.linked_portal_id,
        name: entry.linked_portal_name,
      });
    } else {
      setChecked(false);
      setLinkData("");
    }
  };
  const clearEditModal = () => {
    setShowEditModal(false);
  };

  const handleSave = () => {
    if (!email || !emailIsValid(email)) {
      updateError("Please enter a valid email");
    } else if (!name) {
      updateError("Please enter a name");
    } else if (checked && !linkData) {
      updateError("Please select a trainer");
    } else {
      const body = {
        prevAccountData: prevAccountData,
        newAccountData: {
          id: prevAccountData.id,
          email_address: email,
          name: name,
          link_data: {
            trainer_id: checked ? linkData.id : "",
          },
        },
      };
      editPortalAccount(user.id, body)
        .then((res) => {
          clearEditModal();
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
          openSnackbar("Account successfully edited", false);
        })
        .catch((err) => {
          openSnackbar("An error has occured during edit", true);
        });
    }
  };

  const renderSortArrows = (isSorting, reverse) => {
    return (
      <div style={{ display: "inline-block", marginLeft: "8px" }}>
        <ArrowsGroup>
          <ArrowUp fill={isSorting && reverse ? "#FFFFFF" : "#999999"} />
          <div style={{ height: "3px" }}></div>
          <ArrowDown fill={isSorting && !reverse ? "#FFFFFF" : "#999999"} />
        </ArrowsGroup>
      </div>
    );
  };

  const handleSort = (type) => {
    if (type !== sortType.type) {
      setSortType({ type: type, reverse: false });
    } else {
      setSortType({ type: type, reverse: !sortType.reverse });
    }
  };

  const handleSelect = (user_id) => {
    let selection = [...selectedUsers];

    if (selection.includes(user_id)) {
      _.remove(selection, (id) => id === user_id);
    } else {
      selection.push(user_id);
    }
    setSelectedUsers(selection);
  };

  const submitAssign = (trainer) => {
    setBulkLoading(true);
    if (assignType === "assign") {
      assignTrainer(user.id, selectedUsers, trainer)
        .then((res) => {
          setBulkLoading(false);
          setShowAssignModal(false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          setBulkLoading(false);
          console.log(err);
        });
    } else if (assignType === "remove") {
      bulkRemoveTrainer(user.id, selectedUsers, trainer)
        .then((res) => {
          setBulkLoading(false);
          setShowAssignModal(false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          setBulkLoading(false);
          console.log(err);
        });
    }
  };

  const submitGroupEdit = (groupID) => {
    setBulkLoading(true);
    if (groupEditType === "add") {
      assignToGroup(user.id, selectedUsers, groupID)
        .then((res) => {
          setBulkLoading(false);
          setShowGroupModal(false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          setBulkLoading(false);
          console.log(err);
        });
    } else if (groupEditType === "remove") {
      bulkRemoveFromGroup(user.id, selectedUsers, groupID)
        .then((res) => {
          setBulkLoading(false);
          setShowGroupModal(false);
          loadProfile(user.id).then((res) => {
            updateUser(res.data.profile);
          });
        })
        .catch((err) => {
          setBulkLoading(false);
          console.log(err);
        });
    }
  };

  const handleAssignModal = (type) => {
    setShowAssignModal(true);
    setAssignType(type);
  };

  const handleGroupModal = (type) => {
    setShowGroupModal(true);
    setGroupEditType(type);
  };

  const handleSelectAll = () => {
    const allUsers = [];
    accounts.forEach((entry) => {
      allUsers.push(entry.id);
    });

    if (selectedUsers.length === allUsers.length) {
      setSelectedUsers([]);
    } else {
      setSelectedUsers(allUsers);
    }
  };

  const getSelectAllChecked = () => {
    return selectedUsers.length === accounts.length;
  };

  const exportTable = () => {
    const data = [
      [
        "email address",
        "client name",
        "claimed",
        "permissions",
        "created date",
        "assigned trainers",
        "assigned groups",
      ],
    ];
    accounts.forEach((acc) => {
      const trainersText = user.team
        .filter((t) => acc.trainers.includes(t.id))
        .map((t) => t.name)
        .join(",");
      const groupsText = user.groups
        .filter((g) => acc.groups.includes(g.id))
        .map((g) => g.name)
        .join(",");
      data.push([
        acc.email_address,
        acc.name,
        acc.claimed,
        JSON.stringify({
          view: acc.trainer_permission === 1,
          view_photos: acc.trainer_permission_photos === 1,
          edit: acc.trainer_permission_edit === 1,
        }),
        acc.created_at,
        trainersText,
        groupsText,
      ]);
    });
    const csv = Papa.unparse(data);
    const blob = new Blob([csv]);
    let a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob, { type: "text/plain" });
    a.download = "client-export.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  let accounts = _.cloneDeep(user.accounts);
  if (clientSearch.searchTerm !== "") {
    if (clientSearch.searchType === "Email")
      accounts = accounts.filter((client) =>
        client.email_address
          .toLowerCase()
          .includes(clientSearch.searchTerm.toLowerCase())
      );
    else if (clientSearch.searchType === "Name")
      accounts = accounts.filter((client) =>
        client.name
          .toLowerCase()
          .includes(clientSearch.searchTerm.toLowerCase())
      );
  }
  accounts.sort((a, b) => a[sortType.type].localeCompare(b[sortType.type]));
  if (sortType.reverse) {
    accounts.reverse();
  }

  return (
    <Container>
      <TableTitle>
        {accounts.length} Covered Clients
        <Export onClick={exportTable}>Export to .csv</Export>
        <BulkEdit
          highlight={showSelect}
          onClick={() => {
            setShowSelect(!showSelect);
            setSelectedUsers([]);
          }}
        >
          Bulk Edit
        </BulkEdit>
        {showSelect && (
          <>
            <BulkAction
              onClick={() =>
                selectedUsers.length === 0
                  ? openSnackbar("No clients selected.", true)
                  : handleAssignModal("assign")
              }
            >
              Assign trainer
            </BulkAction>
            <BulkAction
              onClick={() =>
                selectedUsers.length === 0
                  ? openSnackbar("No clients selected.", true)
                  : handleAssignModal("remove")
              }
            >
              Remove trainer
            </BulkAction>
            <BulkAction
              onClick={() =>
                selectedUsers.length === 0
                  ? openSnackbar("No clients selected.", true)
                  : handleGroupModal("add")
              }
            >
              Add to group
            </BulkAction>
            <BulkAction
              onClick={() =>
                selectedUsers.length === 0
                  ? openSnackbar("No clients selected.", true)
                  : handleGroupModal("remove")
              }
            >
              Remove from group
            </BulkAction>
          </>
        )}
      </TableTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              {showSelect && (
                <HeadCell>
                  <WhiteCheckbox
                    style={{ color: "#FFF" }}
                    checked={getSelectAllChecked()}
                    onChange={handleSelectAll}
                    inputProps={{ "aria-label": "checkbox" }}
                  />
                </HeadCell>
              )}
              <HeadCell bigWidth onClick={() => handleSort("email_address")}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  Email Address
                  {renderSortArrows(
                    sortType.type === "email_address",
                    sortType.reverse
                  )}
                </div>
              </HeadCell>
              <HeadCell bigWidth onClick={() => handleSort("name")}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  Full Name
                  {renderSortArrows(sortType.type === "name", sortType.reverse)}
                </div>
              </HeadCell>
              <HeadCell>Claimed</HeadCell>
              <HeadCell>Consent</HeadCell>
              {/* <HeadCell bigWidth>Status</HeadCell> */}
              <HeadCell bigWidth>Created Date</HeadCell>
              <HeadCell>Trainers</HeadCell>
              <HeadCell>Groups</HeadCell>
              <HeadCell style={{ textAlign: "center", width: "120px" }}>
                Actions
              </HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {accounts.map((entry, index) => (
              <TableBodyRow key={entry.id}>
                {showSelect && (
                  <DataCell>
                    <WhiteCheckbox
                      checked={selectedUsers.includes(entry.id)}
                      onChange={() => handleSelect(entry.id)}
                      inputProps={{ "aria-label": "checkbox" }}
                    />
                  </DataCell>
                )}
                <DataCell>
                  {entry.email_address}
                  {entry.linked_portal_id && (
                    <DarkTooltip
                      arrow
                      title={
                        <p>
                          This account is linked to the trainer{" "}
                          {entry.linked_portal_name}
                        </p>
                      }
                    >
                      <LinkIcon
                        style={{
                          fill: "#b532e5",
                          marginLeft: "4px",
                          transform: "translateY(6px) rotate(45deg)",
                        }}
                      />
                    </DarkTooltip>
                  )}
                </DataCell>
                <DataCell>{entry.name}</DataCell>
                <DataCell>{entry.claimed === 1 ? "Yes" : "No"}</DataCell>
                <ButtonCell>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "4px",
                        marginRight: "2px",
                        height: 42,
                        width: 42,
                      }}
                    >
                      <BiggerFontTooltip title="Allow profile view">
                        <Icon
                          style={{
                            color:
                              entry.trainer_permission === 1
                                ? theme.color.primary
                                : "#b9b9b9",
                          }}
                        >
                          article
                        </Icon>
                      </BiggerFontTooltip>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "4px",
                        marginRight: "2px",
                        height: 42,
                        width: 42,
                      }}
                    >
                      <BiggerFontTooltip title="Allow progress photos view">
                        <Icon
                          style={{
                            color:
                              entry.trainer_permission_photos === 1
                                ? theme.color.primary
                                : "#b9b9b9",
                          }}
                        >
                          camera_alt
                        </Icon>
                      </BiggerFontTooltip>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "4px",
                        marginRight: "2px",
                        height: 42,
                        width: 42,
                      }}
                    >
                      <BiggerFontTooltip title="Allow edits">
                        <Icon
                          style={{
                            color:
                              entry.trainer_permission_edit === 1
                                ? theme.color.primary
                                : "#b9b9b9",
                          }}
                        >
                          edit
                        </Icon>
                      </BiggerFontTooltip>
                    </div>
                  </div>
                </ButtonCell>
                {/* <DataCell>{entry.status}</DataCell> */}
                <DataCell number>
                  {moment.utc(entry.created_at).format("MMM D, YYYY")}
                </DataCell>
                <DataCell>
                  {user.team.length !== 0 ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {user.team.map((trainer, index) => {
                        if (entry.trainers.includes(trainer.id)) {
                          return (
                            <span
                              key={trainer.id}
                              style={{
                                marginRight: "4px",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                              }}
                            >
                              {trainer.name}
                            </span>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  ) : (
                    <p>None</p>
                  )}
                </DataCell>
                <DataCell>
                  {user.groups.length !== 0 ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      {user.groups.map((group, index) => {
                        if (entry.groups.includes(group.id)) {
                          return (
                            <span
                              key={index}
                              style={{
                                marginRight: "4px",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                width: "160px",
                                overflow: "hidden",
                              }}
                            >
                              {group.name}
                            </span>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  ) : (
                    <p>None</p>
                  )}
                </DataCell>
                <DataCell style={{ width: "120px" }}>
                  <Row style={{ justifyContent: "center" }}>
                    <CustomPopover clientTable button={<MoreVertIcon />}>
                      {entry.claimed === 1 &&
                        entry.trainer_permission === 1 && (
                          <PopoverListItem
                            icon={<SearchIcon />}
                            text="Inspect"
                            onClick={() => {
                              props.history.push(
                                "/dashboard/inspect/" + entry.id + "/overview"
                              );
                            }}
                          />
                        )}
                      <TrainerButton
                        button={
                          <PopoverListItem
                            icon={<AddCircle />}
                            text="Trainers"
                            onClick={() => {}}
                          />
                        }
                        assignedTrainers={entry.trainers}
                        accountID={entry.id}
                      />
                      <GroupButton
                        button={
                          <PopoverListItem
                            icon={<People />}
                            text="Groups"
                            onClick={() => {}}
                          />
                        }
                        assignedGroups={entry.groups}
                        accountID={entry.id}
                      />
                      <PopoverListItem
                        icon={<EditIcon />}
                        text="Edit"
                        hideOnClick
                        onClick={() => {
                          openEditModal(entry);
                        }}
                      />
                      <PopoverListItem
                        icon={<DeleteIcon />}
                        iconColor="#da0f0f"
                        text="Delete"
                        hideOnClick
                        onClick={() => {
                          updateShowModal(true);
                          updatedeletionID(entry.id);
                          updatedeletionEmail(entry.email_address);
                        }}
                      />
                    </CustomPopover>
                  </Row>
                </DataCell>
              </TableBodyRow>
            ))}
          </TableBody>
        </Table>

        <Modal
          title={`Remove Account`}
          message={`Removing this account will immediately deactivate it. The user can still log in, but must enter a payment method and choose a subscription to continue using the Avatar Nutrition service.`}
          submitLabel="Remove"
          open={showModal}
          onClose={() => updateShowModal(false)}
          handleSubmit={() => handleDelete(deletionID)}
          warning
          disabled={loading}
          isLoading={loading}
        >
          <RemoveText>{deletionEmail}</RemoveText>
        </Modal>

        <Modal
          title="Edit account"
          submitLabel="Confirm"
          open={showEditModal}
          onClose={() => setShowEditModal(false)}
          handleSubmit={handleSave}
        >
          <Input
            error={Boolean(error)}
            disabled
            label="Email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={updateEmail}
          />
          <EmailText>
            <InfoIcon />
            To change a client's covered email address, delete this client and
            add a new covered client.
          </EmailText>
          <Input
            error={Boolean(error)}
            label="Full Name"
            value={name}
            onChange={updateName}
          />
          <LinkContainer>
            <div>
              <Checkbox
                color="default"
                checked={checked}
                onChange={() => setChecked(!checked)}
                inputProps={{ "aria-label": "checkbox" }}
              />
              <p>Change client account to coach account?</p>
              <HelpTip message="If you have given a coach app access by adding them as a 'client' you can mark that account as a coach so they can message clients on their app." />
            </div>
          </LinkContainer>
          {checked && (
            <TrainerLinkButton linkData={linkData} setLinkData={setLinkData} />
          )}
          {checked && linkData && (
            <WarningMessage>
              {`This account is intended to be used by a coach. It will be able to view the shared trainer message channels of clients inside of the ${
                theme.name === "AVATAR"
                  ? "Avatar Nutrition"
                  : "Fit Body Nutrition"
              } app.`}
            </WarningMessage>
          )}
          {error && <ErrorMessage>{error}</ErrorMessage>}
        </Modal>
      </TableContainer>

      <BulkAssignTrainer
        assignType={assignType}
        open={showAssignModal}
        onClose={() => setShowAssignModal(false)}
        handleSubmit={submitAssign}
        disabled={bulkLoading}
        isLoading={bulkLoading}
      />

      <BulkEditGroups
        editType={groupEditType}
        open={showGroupModal}
        onClose={() => setShowGroupModal(false)}
        handleSubmit={submitGroupEdit}
        disabled={bulkLoading}
        isLoading={bulkLoading}
      />
    </Container>
  );
};

export default withRouter(AccountsTable);
